import React from "react";
import { HStack, Icon, Box } from "@chakra-ui/react";
import { FaStar, FaRegStar } from "react-icons/fa";

const StarRating = ({
  value,
  onChange,
  max = 5,
  size = 8,
  ariaLabel = "Rating",
}) => {
  const handleKeyDown = (event) => {
    if (event.key === "ArrowRight" || event.key === "ArrowUp") {
      event.preventDefault();
      onChange(Math.min(max, (value || 0) + 1));
    } else if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
      event.preventDefault();
      onChange(Math.max(1, (value || 1) - 1));
    } else if (event.key === "Home") {
      event.preventDefault();
      onChange(1);
    } else if (event.key === "End") {
      event.preventDefault();
      onChange(max);
    }
  };

  return (
    <HStack
      role="radiogroup"
      aria-label={ariaLabel}
      spacing={2}
      tabIndex={0}
      onKeyDown={handleKeyDown}
      outline="none"
      _focusVisible={{ boxShadow: "outline", borderRadius: "md" }}
    >
      {Array.from({ length: max }, (_, i) => i + 1).map((star) => {
        const filled = value >= star;
        return (
          <Box
            key={star}
            as="button"
            type="button"
            role="radio"
            aria-checked={value === star}
            aria-label={`${star} ${star === 1 ? "star" : "stars"}`}
            onClick={() => onChange(star)}
            cursor="pointer"
            lineHeight={0}
            _focus={{ outline: "none" }}
          >
            <Icon
              as={filled ? FaStar : FaRegStar}
              boxSize={size}
              color={filled ? "yellow.400" : "gray.300"}
              transition="color 0.15s ease"
              _hover={{ color: filled ? "yellow.500" : "gray.400" }}
            />
          </Box>
        );
      })}
    </HStack>
  );
};

export default StarRating;
